import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import SAPopconfirm from "../common/confirmation/SAPopconfirm";
import Intervention from "../../services/Intervention";
import moment from 'moment';

import "./Header.css";
import {Col, Row} from "antd";

class Header extends Component {

  onArchiveClick = () => {
    const {intervention} = this.props.fetchIntervention;
    this.props.dispatchArchiveIntervention({id: intervention.id});
  };

  onCancelClick = () => {
    const {intervention} = this.props.fetchIntervention;
    this.props.dispatchCancelIntervention({id: intervention.id});
  };

  onFinishClick = () => {
    const {intervention} = this.props.fetchIntervention;
    this.props.dispatchFinishIntervention({id: intervention.id});
  };

  canArchive = () => {
    const {intervention, intervention: {startDate, endDate}} = this.props.fetchIntervention;
    const running = moment().isBetween(startDate, endDate);
    return (!running || Intervention.hasEndStatus(intervention)) && !Intervention.isArchived(intervention) && !Intervention.isOngoing(intervention)
  };

  canCancel = () => {
    const {intervention} = this.props.fetchIntervention;
    return !Intervention.isTypeMessage(intervention) && !Intervention.isComplete(intervention) && !Intervention.hasEndStatus(intervention);
  };

  canFinish = () => {
    const {intervention} = this.props.fetchIntervention;
    return Intervention.isTypeAppointmentOrBodywork(intervention) && Intervention.isComplete(intervention) && !Intervention.hasEndStatus(intervention);
  };

  goBackHandler = (e) => {
    e.preventDefault();
    const {history} = this.props;
    if (history.location.key) {
      history.goBack();
    } else {
      history.push('/interventions');
    }
  }

  render() {
    const {intl: {formatMessage}, fetchIntervention: {intervention}} = this.props;

    return (
      <header className="main-header main-header--fixed">
        <div className="main-header__left">
          <Link
            to={'..'}
            onClick={(e) => this.goBackHandler(e)}
            className="btn btn-square btn-o-primary"
          >
            <span className="sr-only">Back to overview</span>
            <svg className="bmw-icon" aria-hidden="true">
              <use xlinkHref="#icon-arrow-left"/>
            </svg>
          </Link>
        </div>
        <div className="main-header__right">
          <Row type={"flex"} gutter={16}>
            {this.canFinish() &&
              <Col>
                <SAPopconfirm action="finish" onConfirm={this.onFinishClick}>
                  <button className="btn btn-primary">{formatMessage({id: 'button.finish'})}</button>
                </SAPopconfirm>
              </Col>
            }
            {this.canCancel() &&
              <Col>
                <SAPopconfirm action="cancel" onConfirm={this.onCancelClick}>
                  <button className="btn btn-primary">{formatMessage({id: 'button.cancel'})}</button>
                </SAPopconfirm>
              </Col>
            }
            {this.canArchive() &&
              <Col>
                <SAPopconfirm action="archive" onConfirm={this.onArchiveClick}>
                  <button className="btn btn-primary">{formatMessage({id: 'button.archive'})}</button>
                </SAPopconfirm>
              </Col>
            }
          </Row>
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  fetchIntervention: state.fetchIntervention
});

const mapDispatchToProps = dispatch => ({
  dispatchArchiveIntervention: params => dispatch({type: 'ARCHIVE_INTERVENTION.REQUEST', ...params}),
  dispatchCancelIntervention: params => dispatch({type: 'CANCEL_INTERVENTION.REQUEST', ...params}),
  dispatchFinishIntervention: params => dispatch({type: 'FINISH_INTERVENTION.REQUEST', ...params})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Header))
